var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYogaLegShoulderStretch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 5.5C12.5 6.42826 12.8687 7.3185 13.5251 7.97487C14.1815 8.63125 15.0717 9 16 9C16.9283 9 17.8185 8.63125 18.4749 7.97487C19.1313 7.3185 19.5 6.42826 19.5 5.5C19.5 4.57174 19.1313 3.6815 18.4749 3.02513C17.8185 2.36875 16.9283 2 16 2C15.0717 2 14.1815 2.36875 13.5251 3.02513C12.8687 3.6815 12.5 4.57174 12.5 5.5V5.5Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 12H4C3.46957 12 2.96086 12.2107 2.58579 12.5858C2.21071 12.9609 2 13.4696 2 14C2 14.5304 2.21071 15.0391 2.58579 15.4142C2.96086 15.7893 3.46957 16 4 16H14V20H12C10.4092 20.0018 8.88414 20.6345 7.75931 21.7593C6.63447 22.8841 6.00176 24.4092 6 26V28C6 28.5304 6.21071 29.0391 6.58579 29.4142C6.96086 29.7893 7.46957 30 8 30C8.53043 30 9.03914 29.7893 9.41421 29.4142C9.78929 29.0391 10 28.5304 10 28V26C10 25.4696 10.2107 24.9609 10.5858 24.5858C10.9609 24.2107 11.4696 24 12 24H14.764L16.1053 26.684C16.6008 27.6818 17.3654 28.5211 18.3128 29.107C19.2602 29.693 20.3527 30.0023 21.4667 30H24C24.5304 30 25.0391 29.7893 25.4142 29.4142C25.7893 29.0391 26 28.5304 26 28C26 27.4696 25.7893 26.9609 25.4142 26.5858C25.0391 26.2107 24.5304 26 24 26H21.4667C21.0951 26.0013 20.7307 25.8984 20.4146 25.703C20.0986 25.5076 19.8436 25.2276 19.6787 24.8947L18 21.528V16H28C28.5304 16 29.0391 15.7893 29.4142 15.4142C29.7893 15.0391 30 14.5304 30 14C30 13.4696 29.7893 12.9609 29.4142 12.5858C29.0391 12.2107 28.5304 12 28 12Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 20H18",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYogaLegShoulderStretch);
export default __webpack_public_path__ + "static/media/YogaLegShoulderStretch.f2e136cef402a9c3b93f0a02de396e99.svg";
export { ForwardRef as ReactComponent };